import { translate, WIKIPEDIA } from 'iuliia';

export const convertTextToUrl = (text: string) => {
    return translate(text, WIKIPEDIA)
        .toLowerCase()
        .replaceAll(' ', '-')
        .replace(/[^a-z\-0-9_]/g, '');
};
